import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { window, document } from '../../../../helpers/BrowserHelpers';
import EventTypes from '../../types/EventTypes';
import Header from './Header';
import ColumnsRow from './ColumnsRow';
import RecordRow from './RecordRow';
import { PlusIcon } from '../../../Icons';
import { DATABASE_ADD_ROW } from '../../../../types/AnalyticsTypes';
import generateKey from '../../utils/generateKey';
import './index.css';
export var TABLE_CONTAINER_CLASSNAME = 'slite-editor-database-table-wrapper';

var DatabaseTableView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseTableView, _React$PureComponent);

  function DatabaseTableView(props, context) {
    var _this;

    _classCallCheck(this, DatabaseTableView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatabaseTableView).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "createRecord", function () {
      var database = _this.props.database;
      var newRecordKey = generateKey();
      var firstColumn = database.getFirstColumn();
      database.insertRecord({
        key: newRecordKey
      }).focus(newRecordKey, firstColumn.key).command('track', DATABASE_ADD_ROW, {
        source: 'Click new record'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEvent", function (handler, event) {
      _this.props.database.run(handler, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentEvent", function (handler, event) {
      if (!_this.props.database.isActive()) {
        return;
      }

      _this.onEvent(handler, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowMouseDown", function (event) {
      var database = _this.props.database;

      if (!database.isElementInDatabase(event.target) && database.isActive()) {
        database.blur();
      }
    });

    _this.containerRef = React.createRef();
    _this.handlers = EventTypes.reduce(function (acc, handler) {
      acc[handler] = function (event) {
        return _this.onEvent(handler, event);
      };

      return acc;
    }, {});
    _this.documentHandlers = {
      copy: function copy(event) {
        return _this.onDocumentEvent('onCopy', event);
      },
      cut: function cut(event) {
        return _this.onDocumentEvent('onCut', event);
      },
      paste: function paste(event) {
        return _this.onDocumentEvent('onPaste', event);
      },
      keydown: function keydown(event) {
        return _this.onDocumentEvent('onKeyDown', event);
      }
    };
    return _this;
  }

  _createClass(DatabaseTableView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.database.setElement(this.containerRef.current);
      window.addEventListener('mousedown', this.onWindowMouseDown, false);
      Object.entries(this.documentHandlers).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            eventName = _ref2[0],
            handler = _ref2[1];

        document.addEventListener(eventName, handler);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.onWindowMouseDown, false);
      Object.entries(this.documentHandlers).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            eventName = _ref4[0],
            handler = _ref4[1];

        document.removeEventListener(eventName, handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          database = _this$props.database,
          selection = _this$props.selection;
      var records = database.getSortedRecords();
      var sort = database.getActiveSort();
      return React.createElement("div", Object.assign({
        "data-qa": "database",
        tabIndex: -1,
        ref: this.containerRef,
        className: classNames('slite-editor-database', 'slite-design-system')
      }, this.handlers), React.createElement(Header, {
        database: database,
        title: database.value.attributes.title,
        showOptions: this.props.database.isFocusInDatabase(),
        isOrderFrozen: Boolean(database.getFrozenOrder())
      }), React.createElement("div", {
        className: TABLE_CONTAINER_CLASSNAME
      }, React.createElement("div", {
        className: "flexbox"
      }, React.createElement("table", {
        className: "slite-editor-database-table"
      }, React.createElement(ColumnsRow, {
        database: database,
        columns: this.props.value.columns,
        selection: selection,
        sort: sort
      }), React.createElement("tbody", null, records.map(function (record, index) {
        return React.createElement(RecordRow, {
          key: record.key,
          rowIndex: index,
          database: database,
          columns: database.value.columns,
          record: record,
          selection: database.getActiveRecordKey() === record.key || database.isInSelectedKeys(record.key) ? selection : null // Re-render only the de-selected row and the selected one

        });
      }), !database.readOnly && React.createElement("tr", null, React.createElement("td", {
        className: "slite-editor-database-cell",
        colSpan: Object.keys(this.props.value.columns).length + 1
      }, React.createElement("div", {
        "data-qa": "database-records-new",
        onClick: this.createRecord,
        className: classNames('pointer', 'transition', 'flexbox', 'padding-vertical-small', 'shade-30 shade-10-on-hover font-size-large')
      }, React.createElement("div", {
        className: "flexbox padding-horizontal-normal",
        style: {
          position: 'sticky',
          left: 0
        }
      }, React.createElement("div", {
        className: "margin-right-normal"
      }, React.createElement(PlusIcon, {
        style: {
          verticalAlign: -1
        },
        size: 12
      })), 'New record')))))))));
    }
  }]);

  return DatabaseTableView;
}(React.PureComponent);

export { DatabaseTableView as default };